import { render } from "./AposInputBox.vue?vue&type=template&id=19565c92&scoped=true"
import script from "./AposInputBox.vue?vue&type=script&lang=js"
export * from "./AposInputBox.vue?vue&type=script&lang=js"

import "./AposInputBox.vue?vue&type=style&index=0&id=19565c92&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19565c92"],['__file',"box-field/ui/apos/components/AposInputBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19565c92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19565c92', __exports__)) {
    api.reload('19565c92', __exports__)
  }
  
  module.hot.accept("./AposInputBox.vue?vue&type=template&id=19565c92&scoped=true", () => {
    api.rerender('19565c92', render)
  })

}


export default __exports__